import React, { useEffect, useState, useRef, useContext } from 'react';
import { Container, Row, Col, Card, Button, Modal, Image, ListGroup, Carousel, Form, Alert } from 'react-bootstrap';
import { Award, ClockHistory, PencilSquare, People, PersonBadge, Trash } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthProvider.js' // eslint-disable-line no-unused-vars
import axios from 'axios';


const PostModal = ({ show, onHide, post }) => {
    const {auth, setAuth} = useContext(AuthContext)
    const navigate = useNavigate()
    const [mount, setMount] = useState(false)
    const [loading, isLoading] = useState(true)

    useEffect(() => {
        setMount(true)
    }, [])

    useEffect(() => {
        if (mount) isLoading(false)
    }, [mount])

    const deletePost = async (id) => {
        try {
            const response = await axios.delete(`/general/posts/delete/${id}`)
            console.log(response.data)
            onHide()
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
        
            </Modal.Header>
            <Modal.Body>
                <h5>{post.title}</h5>
                <p>{post.description}</p>
                <span className='text-muted'>{post.author} • {new Date(post.date_created).toLocaleDateString('en-US')}</span>
                <hr />
                { auth.role === 'administrator' && <Button variant="outline-danger" onClick={() => deletePost(post.id)}>Delete</Button> }
            </Modal.Body>
        </Modal>
    )
}

const RemainderModal = ({ show, onHide, setPosts }) => {
    const {auth, setAuth} = useContext(AuthContext)
    const [mount, setMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [errMsg, setErrMsg] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')

    useEffect(() => {
        setMount(true)
    }, [])

    useEffect(() => {
        if (mount) isLoading(false)
    }, [mount])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setErrMsg('')
        console.log(auth)
        const formData = {
            title: title,
            description: description,
            author: auth.displayname,
        }
        try {
            const response = await axios.post('/general/posts/add', formData)
            console.log(response.data.posts)
            onHide()
            setErrMsg()
        } catch (error) {
            setErrMsg('Error posting this note. Please try again later.')
            console.error(error)
        }
    }

    if (!loading) return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Post to Community</Modal.Title>
            </Modal.Header>
                <Modal.Body>
                    {/* <div className='mb-3' style={{ textAlign: "center" }}>
                        <p className='text-muted' style={{ fontSize: "12px" }}>
                            Disclaimer: Posts will expire after 14 days.
                        </p>
                    </div>                     */}
                    { errMsg && <Alert variant="danger">{errMsg}</Alert> }
                <Form onSubmit={handleSubmit}>
                    <Form.Group className='mb-3' controlId="title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Enter title" 
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className='mb-3' controlId="description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3} 
                            placeholder="Enter description" 
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button  className='mb-3'  style={{ width: "100%" }} variant="outline-warning" type="submit">Post!</Button>
                </Form>
                </Modal.Body>
        </Modal>
    )

}
export default function HeroComponent() {
    const {auth, setAuth} = useContext(AuthContext)
    const navigate = useNavigate()
    const [posts, setPosts] = useState([])
    const [isMounted, setIsMounted] = useState(false)
    const [loading, setLoading] = useState(true)
    const [showRemainderModal, setShowRemainderModal] = useState(false)

    const [showPostModal, setShowPostModal] = useState(false)
    const [selectedPost, setSelectedPost] = useState(null)

    const getPosts = async () => {
        try {
            const response = await axios.get('/general/posts/all')
            console.log(response.data.posts)
            setPosts(response.data.posts)
        } catch (error) {
            console.error(error)
        }

    }
    useEffect(() => {
        getPosts()
        setIsMounted(true)
    }, [])

    useEffect(() => {
        if (!showRemainderModal && !showPostModal) {
            getPosts()
        }

    }, [showRemainderModal, showPostModal])

    useEffect(() => {
        if (isMounted) setLoading(false)
    }, [isMounted])



    if (!loading) return (
        <>
            { showPostModal && <PostModal show={showPostModal} onHide={() => setShowPostModal(false)} post={selectedPost} /> }
            { showRemainderModal && <RemainderModal show={showRemainderModal} onHide={() => setShowRemainderModal(false)} setPosts={setPosts} /> }
            <Row id="home-wrapper" >
                <div id="home-wrapper-col" className="overlay"> 
                    <Row className=''>
                        <Col className='mx-auto' style={{ textAlign: "center"}} xs={11} md={9} lg={8} >
                            {/* { homeSlides() } */}
                                <div className='home-banner-container fade-in'>
                                    <div className='home-banner-text'>
                                        <h1 style={{ fontWeight: "700"}}>The Canadian Society of Aerospace Medicine (CSAM) </h1>
                                        <h4 style={{ textAlign: "center", fontFamily: "Times New Roman" }}>
                                            The official organization representing aerospace medicine professionals in Canada.
                                        </h4>

                                        
                                            <nav className="home-banner-links" aria-label="Explore CSAM">
                                                <button type="button" className="home-banner-link" onClick={() => navigate("/about")}>
                                                    <People aria-hidden="true" />
                                                    <span>
                                                        <span className="home-banner-link-kicker">The society</span>
                                                        <span className="home-banner-link-title">About Us</span>
                                                    </span>
                                                </button>
                                                <button type="button" className="home-banner-link" onClick={() => navigate("/membership")}>
                                                    <PersonBadge aria-hidden="true" />
                                                    <span>
                                                        <span className="home-banner-link-kicker">Join</span>
                                                        <span className="home-banner-link-title">Membership</span>
                                                    </span>
                                                </button>
                                                <button type="button" className="home-banner-link" onClick={() => navigate("/history")}>
                                                    <ClockHistory aria-hidden="true" />
                                                    <span>
                                                        <span className="home-banner-link-kicker">Our story</span>
                                                        <span className="home-banner-link-title">CSAM History</span>
                                                    </span>
                                                </button>
                                                <button type="button" className="home-banner-link" onClick={() => navigate("/giants-of-aerospace-medicine")}>
                                                    <Award aria-hidden="true" />
                                                    <span>
                                                        <span className="home-banner-link-kicker">Pioneers</span>
                                                        <span className="home-banner-link-title">Giants of Aerospace Medicine</span>
                                                    </span>
                                                </button>
                                            </nav>
{/* 

                                    { posts.length > 0 && <div className='key-remainders-div'>
                                        <div className='key-remainders-div-content'>
                                            <h5 className='mb-3'> Community Posts { auth.role === 'administrator' ? 
                                                <PencilSquare 
                                                className='ms-2 hover-icon' 
                                                size={14}   
                                                onClick={ (e)=> setShowRemainderModal(true) } /> : null } </h5>
                                            { posts.length > 0 && posts.map((post, index) => (
                                                index < 3 && <p key={post.id} className='posts-text' onClick={() => {
                                                    setShowPostModal(true);
                                                    setSelectedPost(post);
                                                }}>
                                                    {post.title}
                                                </p>
                                            )) }
                                        </div>
                                    </div> }

                                    { posts.length == 0 && auth.role === 'administrator' && <div className='key-remainders-div'>
                                        <div className='key-remainders-div-content'>
                                            <h5 className='mb-3'> Community Posts { auth.role === 'administrator' ? 
                                                <PencilSquare 
                                                className='ms-2 hover-icon' 
                                                size={14}   
                                                onClick={ (e)=> setShowRemainderModal(true) } /> : null } </h5>
                                            { posts.length > 0 && posts.map((post, index) => (
                                                index < 3 && <p key={post.id} className='posts-text' onClick={() => {
                                                    setShowPostModal(true);
                                                    setSelectedPost(post);
                                                }}>
                                                    {post.title}
                                                </p>
                                            )) }
                                        </div>
                                    </div> } */}




                                        
                                    </div>

                                    {/* key remainders */}

                                </div>            
                        </Col>
                    </Row>
                </div>
            </Row>
            
        </>
    )

}